module.exports = __webpack_public_path__ + "img/bg_intro_2_3.7b4dd64c.svg";